import { useEffect, useRef, useState } from "react";
import { useImmer } from "use-immer";
import SimpleReactValidator from "simple-react-validator";
import {
  getTenantLoyaltySettingsApi,
  updateTenantLoyaltySettingsApi,
} from "../apis/loyaltyApis";
import { errorMessage, successMessage } from "../../../utils";

export const useLoyaltyConfig = () => {
  const [, setForceUpdate] = useState(0);
  const [state, setState] = useImmer({
    formData: { loyalty_term: "" },
    isLoading: true,
    isSubmitting: false,
    hasChanges: false,
  });

  const formValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    }),
  );

  useEffect(() => {
    fetchLoyaltySettings();
  }, []);

  const fetchLoyaltySettings = async () => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });

      const response = await getTenantLoyaltySettingsApi();
      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to fetch tenant loyalty settings",
        );
      }

      setState((draft) => {
        draft.formData = response.data;
      });
    } catch (error) {
      errorMessage(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch tenant loyalty settings",
      );
    } finally {
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const updateLoyaltySettings = async () => {
    try {
      setState((draft) => {
        draft.isSubmitting = true;
      });

      const response = await updateTenantLoyaltySettingsApi(state.formData);
      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to update tenant loyalty settings",
        );
      }

      setState((draft) => {
        draft.formData = response.data;
        draft.hasChanges = false;
      });
      successMessage(response.message);
      fetchLoyaltySettings();
    } catch (error) {
      errorMessage(
        error.response?.data?.message ||
          error.message ||
          "Failed to update tenant loyalty settings",
      );
    } finally {
      setState((draft) => {
        draft.isSubmitting = false;
      });
    }
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setState((draft) => {
      draft.formData[name] = value;
      draft.hasChanges = true;
    });
  };

  const onSubmit = () => {
    if (formValidator.current.allValid()) {
      updateLoyaltySettings();
    } else {
      formValidator.current.showMessages();
      setForceUpdate((previous) => previous + 1);
    }
  };

  return { formValidator, state, onChange, onSubmit };
};
